import { fromJS } from 'immutable';
import deepMerge from '../utils/deepMerge';
import { ACTION_PREFIX, ANYTIME } from '../constants/packagesConstants';

export const SET_START_LOCATION = `${ACTION_PREFIX}/SET_START_LOCATION`;
export const SET_END_LOCATION = `${ACTION_PREFIX}/SET_END_LOCATION`;
export const SET_START_DATE = `${ACTION_PREFIX}/SET_START_DATE`;
export const SET_END_DATE = `${ACTION_PREFIX}/SET_END_DATE`;
export const SET_DATES = `${ACTION_PREFIX}/SET_DATES`;
export const SET_START_TIME = `${ACTION_PREFIX}/SET_START_TIME`;
export const SET_END_TIME = `${ACTION_PREFIX}/SET_END_TIME`;
export const SET_ROOMS_TRAVELERS = `${ACTION_PREFIX}/SET_ROOMS_TRAVELERS`;
export const SWAP_LOCATIONS = `${ACTION_PREFIX}/SWAP_LOCATIONS`;
export const SET_REQUEST = `${ACTION_PREFIX}/SET_REQUEST`;
export const SET_COUNTRY_OF_RESIDENCE = `${ACTION_PREFIX}/SET_COUNTRY_OF_RESIDENCE`;
export const SET_INAV_LOCATION = `${ACTION_PREFIX}/SET_INAV_LOCATION`;

export const setRequestAction = (request) => ({
  type: SET_REQUEST,
  request,
});

export const setStartLocationAction = (startLocation) => ({
  type: SET_START_LOCATION,
  startLocation,
});

export const setEndLocationAction = (endLocation) => ({
  type: SET_END_LOCATION,
  endLocation,
});

export const setDatesAction = ({ startDate, endDate }) => ({
  type: SET_DATES,
  startDate,
  endDate,
});

export const setStartTimeAction = (startTime) => ({
  type: SET_START_TIME,
  startTime,
});

export const setEndTimeAction = (endTime) => ({
  type: SET_END_TIME,
  endTime,
});

export const setRoomsTravelersAction = (roomsTravelers) => ({
  type: SET_ROOMS_TRAVELERS,
  roomsTravelers,
});

export const swapLocationsAction = () => ({
  type: SWAP_LOCATIONS,
});

export const setCountryOfResidenceAction = (countryOfResidence) => ({
  type: SET_COUNTRY_OF_RESIDENCE,
  countryOfResidence,
});

export const setInavLocationAction = (inavLocation) => ({
  type: SET_INAV_LOCATION,
  inavLocation,
});

export const DEFAULT_FLIGHT_HOTEL_STATE = fromJS({
  startLocation: {},
  endLocation: {},
  startDate: null,
  endDate: null,
  startTime: ANYTIME,
  endTime: ANYTIME,
  roomsTravelers: [{ adults: 2, children: [], infants: [] }],
  countryOfResidence: '',
});

// eslint-disable-next-line default-param-last -- other order causes render issues
const requestReducer = (state = DEFAULT_FLIGHT_HOTEL_STATE, action) => {
  switch (action && action.type) {
    case SET_START_LOCATION: {
      return state.set('startLocation', fromJS(action.startLocation));
    }
    case SET_END_LOCATION: {
      return state.set('endLocation', fromJS(action.endLocation));
    }
    case SET_DATES: {
      const { startDate, endDate } = action;
      const updatedState = state.set('startDate', startDate);
      return updatedState.set('endDate', endDate);
    }
    case SET_START_TIME: {
      return state.set('startTime', action.startTime);
    }
    case SET_END_TIME: {
      return state.set('endTime', action.endTime);
    }
    case SET_ROOMS_TRAVELERS: {
      return state.set('roomsTravelers', fromJS(action.roomsTravelers));
    }
    case SET_REQUEST: {
      return fromJS(deepMerge(state.toJS(), action.request));
    }
    case SWAP_LOCATIONS: {
      const startLocation = state.get('startLocation');
      const endLocation = state.get('endLocation');
      return state
        .set('startLocation', endLocation)
        .set('endLocation', startLocation);
    }
    case SET_COUNTRY_OF_RESIDENCE: {
      const { countryOfResidence } = action;
      return state.set('countryOfResidence', countryOfResidence);
    }
    case SET_INAV_LOCATION: {
      const { inavLocation } = action;
      return state.set('inavLocation', inavLocation);
    }
    default:
      return state;
  }
};

export default requestReducer;
